import React, { Fragment, useEffect, useState } from 'react';
import PersonalInfo from './PersonalInfo';
import G2gExpPersonalInfo from './G2gExpPersonalInfo';
import RoleForm from './RoleForm';
import G2gExpRoleForm from './G2gExpRoleForm';
import EmailVolumeForm from './EmailVolumeForm';
import G2gExpEmailVolumeForm from './G2gExpEmailVolumeForm';
import CompanyInfo from './CompanyInfo';
import G2gExpCompanyInfo from './G2gExpCompanyInfo';
import Styles from './g2gProfileExp.module.scss';

export const ProfilePage = () => (
  <Fragment>
    <PersonalInfo />
    <RoleForm />
    <EmailVolumeForm />
    <CompanyInfo />
  </Fragment>
);

export const ExperimentProfilePage = () => (
  <Fragment>
    <section className={Styles['profile-section']}>
      <G2gExpPersonalInfo />
      <G2gExpRoleForm />
      <G2gExpEmailVolumeForm />
      <G2gExpCompanyInfo />
    </section>
  </Fragment>
);

export const FormExpManager = () => {
  const experimentID = '16356510482';
  const profilePageID = '16367630380';
  const experimentProfilePageID = '16356760597';

  // Forces React to re-render the component after activating the experiment in useEffect
  const [, setReEvaluate] = useState(false);

  useEffect(() => {
    if (window.optimizely) {
      window.optimizely.push({
        type: 'activate',
      });
    }
    setReEvaluate(true);
  }, []);

  const optimizelyExperiment = window.optimizely && window.optimizely.get ? window.optimizely.get('state').getExperimentStates() : {};
  const experimentVariation = (optimizelyExperiment[experimentID] && optimizelyExperiment[experimentID].variation) ? optimizelyExperiment[experimentID].variation.id : profilePageID;

  if (experimentVariation === experimentProfilePageID) {
    return <ExperimentProfilePage />;
  }
  return <ProfilePage />;
};

export default FormExpManager;
